import { render, staticRenderFns } from "./BoxUnlockDescription.vue?vue&type=template&id=4e18bece&scoped=true&"
import script from "./BoxUnlockDescription.vue?vue&type=script&lang=js&"
export * from "./BoxUnlockDescription.vue?vue&type=script&lang=js&"
import style0 from "./BoxUnlockDescription.vue?vue&type=style&index=0&id=4e18bece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e18bece",
  null
  
)

export default component.exports